import { ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class SaveFreeTextMappingKeywordCommand extends ModelBase {

    public rawGenericServiceProviderEventKeywordID: number = 0;

    public rawGenericServiceProviderEventMappingID: number = 0;

    @Rules.StringLength(100)
    public keyword: string = ""
}